import React from 'react';
import { motion } from 'framer-motion';
interface TextSectionProps {
  children: React.ReactNode;
  className?: string;
  delay?: number;
}
export const TextSection: React.FC<TextSectionProps> = ({
  children,
  className = '',
  delay = 0
}) => {
  return <motion.section initial={{
    opacity: 0,
    y: 30
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-100px'
  }} transition={{
    duration: 0.8,
    delay,
    ease: 'easeOut'
  }} className={`w-full max-w-[680px] mx-auto px-6 py-8 md:py-12 text-lg md:text-xl leading-relaxed md:leading-loose text-gray-300 space-y-6 md:space-y-8 ${className}`} data-id="element-146">
      {children}
    </motion.section>;
};